import React from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { compact } from 'lodash';
import PlanSelector from './plan-selector';
import CustomQuoteCallout from './custom-quote-callout';
import { CSRF_TOKEN } from 'constants';
import { shouldContactSales } from '../shared/helpers';

class Payment extends React.Component {
  static propTypes = {
    defaultTransfer: PropTypes.string.isRequired,
    defaultRetention: PropTypes.string.isRequired,
    currentPlanAmountDollars: PropTypes.number.isRequired,
    billedMonthly: PropTypes.bool,
    setPaymentWrapperCss: PropTypes.func
  }

  state = {
    transfer: this.props.defaultTransfer,
    retention: this.props.defaultRetention,
    amount: null,
    showCallout: false,
    billedMonthly: this.props.billedMonthly,
    canChangePlan: true
  }

  componentDidMount() {
    if (this.state.transfer === 'free') {
      this.setState(this.freePlan(), this.computeAmount);
    } else {
      this.computeAmount();
    }

    setPaymentWrapperCss(this.props.billedMonthly);
  }

  freePlan() {
    return { transfer: 'free', retention: '1d' };
  }

  planName() {
    let prefix = null;

    if (this.state.transfer === 'free') {
      return 'free';
    }

    if (!this.state.billedMonthly) {
      prefix = 'annual';
    }

    return compact([prefix, this.state.transfer, this.state.retention]).join('_');
  }

  billingInterval() {
    return this.state.billedMonthly ? 'monthly' : 'yearly';
  }

  computeAmount = () => {
    let amount = this.props.planPrices[this.planName()];

    if (typeof amount === 'undefined') amount = 0;

    this.setState({ amount: amount }, () => {
      this.checkForDowngrade();
      this.determineCalloutVisibility();
    });
  }

  checkForDowngrade = () => {
    const currentAmount = this.props.currentPlanAmountDollars;
    const newAmount = this.props.planPrices[this.planName()];
    const isDowngrading = (newAmount < currentAmount);

    this.setState({ canChangePlan: !isDowngrading });
  }

  onLogTransferChange = (e) => {
    const selectedValue = e.target.value;
    let newState = { transfer: selectedValue };

    if (selectedValue === 'free') {
      newState = this.freePlan();
    }

    this.setState(newState, this.computeAmount);
  }

  onLogRetentionChange = (e) => {
    this.setState({ retention: e.target.value }, this.computeAmount);
  }

  onDowngradeAcknowledgement = (e) => {
    this.setState({
      canChangePlan: e.target.checked
    });
  }

  determineCalloutVisibility() {
    this.setState({ showCallout: shouldContactSales(this.state.transfer) });
  }

  toggleBillingInterval = (e) => {
    e.preventDefault();

    this.setState((prevState, props) => { return { billedMonthly: !prevState.billedMonthly } }, () => {
      this.computeAmount();
      this.props.setPaymentWrapperCss(this.state.billedMonthly);
    });
  }

  render() {
    return (
      <div className="plan-builder grid flex">
        <div className="grid-cell">
          <PlanSelector
            plans={this.props.plans}
            transfer={this.state.transfer}
            retention={this.state.retention}
            disabledRetention={this.state.transfer === 'free'}
            showHelpCallout={true}
            onLogTransferChange={this.onLogTransferChange}
            onLogRetentionChange={this.onLogRetentionChange}
          />
        </div>
        <div className="grid-cell mod-submit">
          <p className="amount">${Number(this.state.amount).toLocaleString()}<span>/{this.billingInterval()}</span></p>
          <p className="billing-interval-toggle">
            or <a href="/account/payment" onClick={this.toggleBillingInterval}>
              5% { this.state.billedMonthly ? "less paid yearly" : "more paid monthly" }
            </a>
          </p>
          <form action="/account/update_plan" method="POST">
            <input type="hidden" name="authenticity_token" value={CSRF_TOKEN} />
            <input type="hidden" value={this.planName()} name="plan" />
            <button className="btn lg mod-primary" disabled={!this.state.canChangePlan}>Activate Selected Plan</button>
            {
              !this.state.canChangePlan &&
                <div className="downgrade-acknowledgement">
                  <p>
                    <strong>Important</strong>: Downgrading your plan is effective immediately and no refunds will be applied.
                  </p>
                  <p>
                    <label>
                      <input type="checkbox" value="1"
                        defaultChecked={false}
                        onChange={this.onDowngradeAcknowledgement}
                      /> Yes, I accept these terms
                    </label>
                  </p>
                </div>
            }
          </form>

          { this.state.showCallout && this.state.canChangePlan && <CustomQuoteCallout /> }
        </div>
      </div>
    );
  }
}

// TEMPORARY
// unfortunate side effect of mixing Rails/React, this function is responsible
// for updating a wrapper CSS class based on monthly/yearly billing interval
function setPaymentWrapperCss(monthly) {
  const wrapper = document.getElementById('billing-interval-wrapper');

  wrapper.classList.toggle('billing-interval-yearly', !monthly);
}

ReactDOM.render(
  <Payment
    plans={PT.formattedPlans}
    planPrices={PT.planPrices}
    defaultTransfer={PT.selectedPlan.transfer}
    defaultRetention={PT.selectedPlan.retention}
    currentPlanAmountDollars={PT.currentPlan.amountDollars}
    billedMonthly={PT.selectedPlan.billedMonthly}
    setPaymentWrapperCss={setPaymentWrapperCss}
  />,
  document.getElementById('react-payment')
);

export default Payment;
